import { AutogenModelQuotePostHist, AutogenRowQuotePostHist } from "./autogen/AutogenModelQuotePostHist";

export class ModelQuotePostHist extends AutogenModelQuotePostHist<RowQuotePostHist> {
    constructor() {
        super(RowQuotePostHist);
    }
}

export class RowQuotePostHist extends AutogenRowQuotePostHist {
}